<template>
  <div class="mbo-obs">
    <MbOverlayStage>
      <MbOverlay :scene="scene"
                 :battle="battle"
                 :post-battle="postBattle"
                 :events="events"
                 :series="series"
                 :title="title"
                 :casters="casters"/>
    </MbOverlayStage>
  </div>
</template>

<script>
import api from '@/api/api'
import MbOverlay from '@/components/MlbbBroadcast/overlay/MbOverlay.vue'
import MbOverlayStage from '@/components/MlbbBroadcast/overlay/MbOverlayStage.vue'
import {createBattleLive} from '@/services/mlbbBattleLive'
import {createBroadcastLive, programOf} from '@/services/mlbbBroadcastLive'
import {loadHeroCatalog} from '@/services/mlbbHeroCatalog'
import {loadGameCatalog} from '@/services/mlbbGameCatalog'
import {parseJudgeId} from '@/common/mlbbBroadcast'

const ROOT_CLASS = 'mbo-obs-root'
const SILENT = {skipErrorToast: true}

/**
 * Вывод графики для OBS (Browser Source 1920×1080): без меню админки, на прозрачном фоне.
 * Всё состояние — трансляция режиссёра (mlbb-broadcasts.{id}): сцена, игра, игра для итогов и данные
 * игр уже с правками (display). Сама страница по состоянию игры ничего не переключает.
 * Отдельно по публичным ручкам: лента событий для килл-фида и игры серии для счёта.
 * Ссылка: /mlbb-broadcast/obs?broadcast={id}. Вход не нужен.
 */
export default {
  name: 'MlbbObsPage',
  components: {MbOverlay, MbOverlayStage},
  data() {
    return {
      broadcastId: null,
      broadcast: null,
      events: [],
      series: [],
      eventsBattleId: null,
      seriesGroupId: null,
      live: null,
      broadcastLive: null,
    }
  },
  computed: {
    program() {
      return programOf(this.broadcast)
    },
    battle() {
      return this.broadcast?.battle || null
    },
    postBattle() {
      return this.program.scene === 'post' ? (this.broadcast?.post_battle || null) : null
    },
    scene() {
      // пока данные выбранной игры не пришли — чистый кадр, а не пустые плашки
      const scene = this.program.scene
      if (scene !== 'none' && scene !== 'post' && !this.battle) return 'none'
      return scene
    },
    title() {
      return this.broadcast?.title || ''
    },
    casters() {
      return Array.isArray(this.broadcast?.casters) ? this.broadcast.casters : []
    },
  },
  watch: {
    'battle.id'(id) {
      this.followEvents(id || null)
    },
    'battle.group_id'() {
      this.loadSeries()
    },
    'battle.state'(state, prev) {
      // игра закончилась — счёт серии изменился
      if (state === 'end' && prev && prev !== 'end') this.loadSeries(true)
    },
  },
  created() {
    loadHeroCatalog()
    loadGameCatalog()
    this.broadcastId = parseJudgeId(this.$route.query.broadcast)
    if (!this.broadcastId) return
    this.broadcastLive = createBroadcastLive({
      broadcastId: this.broadcastId,
      onBroadcast: (raw) => {
        this.broadcast = raw
      },
    })
    this.broadcastLive.start()
  },
  mounted() {
    document.documentElement.classList.add(ROOT_CLASS)
  },
  beforeDestroy() {
    document.documentElement.classList.remove(ROOT_CLASS)
    if (this.broadcastLive) this.broadcastLive.stop()
    this.stopEvents()
  },
  methods: {
    followEvents(battleId) {
      if (battleId === this.eventsBattleId) return
      this.stopEvents()
      this.eventsBattleId = battleId
      this.events = []
      if (!battleId) return
      this.live = createBattleLive({
        battleId,
        eventsOnly: true,
        onEvents: (all) => {
          this.events = all
        },
      })
      this.live.start()
    },

    stopEvents() {
      if (this.live) this.live.stop()
      this.live = null
    },

    async loadSeries(force = false) {
      const groupId = this.battle?.group_id || null
      if (!force && groupId === this.seriesGroupId) return
      this.seriesGroupId = groupId
      if (!groupId) {
        this.series = []
        return
      }
      try {
        const res = await api.mlbbEsports.groupBattles(groupId, SILENT)
        if (groupId !== this.seriesGroupId) return
        this.series = res?.data?.data || []
      } catch (e) {
        // без серии остаётся текущая игра
      }
    },
  },
}
</script>

<style lang="scss">
html.mbo-obs-root,
html.mbo-obs-root body {
  margin: 0;
  overflow: hidden;
  background: transparent !important;
}

html.mbo-obs-root .loader-wrapper { display: none; }

.mbo-obs {
  width: 100vw;

  .mbo-stage {
    border-radius: 0;
    background: transparent;
  }
}
</style>
